const injected = {
  user: null,
  source: null,
  FRONTEND_URL: null,
}

export default injected
